module.exports = __webpack_public_path__ + "img/Login-2.45b7b99a.png";